import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    isSuccess: false
};
var updatePermissionSlice = createSlice({
    name: "updatePermission",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
            state.isSuccess = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isSuccess: true,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true,
                isSuccess: false
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updatePermissionSlice_actions = updatePermissionSlice.actions;
export var fetchData = _updatePermissionSlice_actions.fetchData, fetchDataSuccess = _updatePermissionSlice_actions.fetchDataSuccess, fetchDataFailure = _updatePermissionSlice_actions.fetchDataFailure, resetState = _updatePermissionSlice_actions.resetState;
export default updatePermissionSlice.reducer;
